import React from 'react';
import { TextField } from '@mui/material';

// Custom SearchInput component to replace @deere/ux.uxframe-react SearchInput
export const SearchInput = ({ placeholder, value, onChange, ...props }) => {
  return (
    <TextField
      type="search"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      variant="outlined"
      size="small"
      {...props}
    />
  );
};

export default SearchInput;
